import React from 'react';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 6),
      maxWidth: theme.breakpoints.values.lg,
      margin: 'auto',
      width: '100%',
    },
  },
}));

const SectionContainer = ({ children, className }) => {
  const classes = useStyles();
  return <div className={clsx(classes.container, className)}>{children}</div>;
};

export default SectionContainer;
